module.exports = __webpack_public_path__ + "img/proyecto_12_mv.746a39a0.png";